const MAX_STATUS_CHECKS: number = 3
const STATUS_CHECK_FREQUENCY: number = 750
const DEFAULT_TIMEOUT_ERROR: string = 'Timeout: Maximum number of attempts exceeded.'

export type Timings = {
    maxChecks?: number
    frequency?: number
    errorMessage?: string
}

export class TimingOptions {
    maxChecks: number = MAX_STATUS_CHECKS
    frequency: number = STATUS_CHECK_FREQUENCY
    errorMessage: string = DEFAULT_TIMEOUT_ERROR

    public constructor(timings?: Nullable<Timings>) {
        if (timings) {
            this.maxChecks = timings?.maxChecks ?? MAX_STATUS_CHECKS
            this.frequency = timings?.frequency ?? STATUS_CHECK_FREQUENCY
            this.errorMessage = timings?.errorMessage ?? DEFAULT_TIMEOUT_ERROR
        }
    }
}
